import { Component, Input } from '@angular/core';
import { Company, Product2, Theme } from 'situview-webapi-client';
import { AuthService, BreadcrumbService, StateService, ProductService, Utils, CompanyViewService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { INewProduct } from 'src/app/views';

@Component({
  selector: 'product-themes-tab',
  templateUrl: './product-themes-tab.component.html',
  styleUrls: ['./product-themes-tab.component.scss']
})

export class ProductThemesTabComponent extends SituBaseComponent {
  @Input() product: INewProduct = new Product2();

  themes?: Theme[];

  
  allCompaniesMap: Map<string, Company> | undefined;

  private _loading = 0;
  public get loading(): number { return this._loading; }

  public set loading(val: number) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val != 0);
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService,
    private productService: ProductService,
    private companyViewService: CompanyViewService) {
    super(authService, stateService);

  }

  ngOnInit(): void {
    super.ngOnInit();

    Promise.all([this.getProductThemes(), this.loadCompanies()])
    .then(() => {
      
    });
  }
  
  getProductThemes() {
    if (!this.themes) {
      this.productService.LoadProductThemes(this.product.companyId!, this.product.id!)
      .then(x => {
        if (x) {
          this.themes = x;
        } else {
          this.showMessage("Failed to load workflow history!");
        }
      })
      .catch((err: any) => {
        this.showMessage("Failed to load workflow history!");
      });
    }

    return this.themes;
  }

  getThemeDisplayName(theme: Theme) {
    var themeCompany = this.getCompany(theme.companyId);
    return `${themeCompany?.name} - ${theme.name}`;
  }

  private async loadCompanies() {
    const companies = await this.companyViewService.LoadCompanies();
    this.allCompaniesMap = new Map<string, Company>(companies.map(x => [x.id!, x]));
  }
  
  getCompany(companyId: string | undefined) : Company | undefined {
    return companyId ? this.allCompaniesMap?.get(companyId) : undefined;
  }

  timeAgoString(date?: Date): string {
    return Utils.timeAgoString(date);
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}